module.exports = __webpack_public_path__ + "static/media/PoppinsBold.750ecc1f.woff";